import { useLocation } from 'react-router-dom';
import MapIcon from '@mui/icons-material/Map';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';

import LinkedIconButton from '../LinkedIconButton';

const useStyles = ({ height, footerHeight }) => ({
  container: {
    height,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 8%',
    backgroundColor: '#fff',
    position: 'sticky',
    bottom: footerHeight,
    zIndex: 9999,
  },
});

const BottomMenuMobile = ({ height, footerHeight }) => {
  const { pathname } = useLocation();
  const styles = useStyles({ height, footerHeight });
  return (
    <div id="bottom-menu-container" style={styles.container}>
      <LinkedIconButton to="/map" text="Map" Icon={MapIcon} selected={pathname === '/map'} />
      <LinkedIconButton to="/stats" text="Stats" Icon={LeaderboardIcon} selected={pathname === '/stats'} />
      <LinkedIconButton to="/info" text="Info" Icon={InfoIcon} selected={pathname === '/info'} />
      <LinkedIconButton to="/help" text="Help" Icon={HelpIcon} selected={pathname === '/help'} />
    </div>
  );
};

export default BottomMenuMobile;
